import { computed, ref } from "vue";
import Constants from "@/utils/constants";
import Helper from "@/utils/helper";
import { usePermissionsStore } from "@/stores/permissionsStore.js";

export function useMainMenu() {
  const permissionsStore = usePermissionsStore();

  const companyOptions = [
    { item: Constants.enums.COMPANY_OPTIONS.LCR },
    { item: Constants.enums.COMPANY_OPTIONS.CAP },
    { item: Constants.enums.COMPANY_OPTIONS.ENT },
    { item: Constants.enums.COMPANY_OPTIONS.CSI }
  ];

  // Keep same default behavior as IndexLayout today
  const selectedCompany = ref(Constants.enums.COMPANY_OPTIONS.LCR);

  const menuItems = ref([
    {
      label: "Home",
      icon: "pi pi-home",
      route: Constants.enums.ROUTE_ENUM.HOME,
      company: [],
      permissionID: null
    },
    {
      label: "Jobs",
      icon: "pi pi-briefcase",
      route: `${Constants.enums.ROUTE_ENUM.DASHBOARD}/${Constants.enums.FORM_TEMPLATE_IDS.JOBS_FORM}`,
      company: [],
      permissionID: Constants.enums.FORM_TEMPLATE_IDS.JOBS_FORM
    },
    {
      label: "Doc Center",
      icon: "pi pi-file",
      route: `${Constants.enums.ROUTE_ENUM.DASHBOARD}/${Constants.enums.FORM_TEMPLATE_IDS.DOC_CENTER_FORM}?created_by=USER_ID`,
      company: [],
      permissionID: Constants.enums.FORM_TEMPLATE_IDS.DOC_CENTER_FORM
    },
    {
      label: "FLRA - Form",
      icon: "pi pi-align-justify",
      route: Constants.enums.ROUTE_ENUM.FLRA_FORM,
      company: [Constants.enums.COMPANY_OPTIONS.LCR],
      permissionID: Constants.enums.FORM_TEMPLATE_IDS.FLRA_FORM
    },
    {
      label: "FLHA - Form",
      icon: "pi pi-align-justify",
      route:
        Constants.enums.ROUTE_ENUM.DASHBOARD +
        "/" +
        Constants.enums.FORM_TEMPLATE_IDS.STATIC_FLHA_FORM,
      company: [],
      permissionID: Constants.enums.FORM_TEMPLATE_IDS.STATIC_FLHA_FORM
    },
    {
      label: "Defects - Form",
      icon: "pi pi-align-justify",
      route:
        Constants.enums.ROUTE_ENUM.DASHBOARD +
        "/" +
        Constants.enums.FORM_TEMPLATE_IDS.DEFECTS_FORM,
      company: [],
      permissionID: Constants.enums.FORM_TEMPLATE_IDS.DEFECTS_FORM
    },
    {
      label: "LWI Dashboard",
      icon: "pi pi-align-justify",
      route: Constants.enums.ROUTE_ENUM.LWI_DASHBOARD,
      company: [],
      permissionID: Constants.enums.FORM_TEMPLATE_IDS.LWI_DASHBOARD
    },
    {
      label: "Patrol Weekly Report",
      icon: "pi pi-align-justify",
      route: Constants.enums.ROUTE_ENUM.PATROL_WEEKLY_REPORT_DASHBOARD,
      company: [],
      permissionID: Constants.enums.FORM_TEMPLATE_IDS.PATROL_WEEKLY_REPORT_DASHBOARD
    },
    {
      label: "Inspections - Form",
      icon: "pi pi-align-justify",
      route:
        Constants.enums.ROUTE_ENUM.DASHBOARD +
        "/" +
        Constants.enums.FORM_TEMPLATE_IDS.INSPECTION_FORM,
      company: [],
      permissionID: Constants.enums.FORM_TEMPLATE_IDS.INSPECTION_FORM
    },
    {
      label: "Blade Purchase - Form",
      icon: "pi pi-align-justify",
      route:
        Constants.enums.ROUTE_ENUM.DASHBOARD +
        "/" +
        Constants.enums.FORM_TEMPLATE_IDS.BLADES_PURCHASE_FORM,
      company: [],
      permissionID: Constants.enums.FORM_TEMPLATE_IDS.BLADES_PURCHASE_FORM
    },
    {
      label: "Blade Accessories - Form",
      icon: "pi pi-align-justify",
      route:
        Constants.enums.ROUTE_ENUM.DASHBOARD +
        "/" +
        Constants.enums.FORM_TEMPLATE_IDS.BLADES_ACCESSORIES_FORM,
      company: [],
      permissionID: Constants.enums.FORM_TEMPLATE_IDS.BLADES_ACCESSORIES_FORM
    },
    {
      label: "Blade Shop Dashboard",
      icon: "pi pi-align-justify",
      route: Constants.enums.ROUTE_ENUM.BLADES_SHOP_DASHBOARD,
      company: [],
      permissionID: Constants.enums.FORM_TEMPLATE_IDS.BLADES_SHOP_DASHBOARD
    },
    {
      label: "Master Unit Dashboard",
      icon: "pi pi-align-justify",
      route: Constants.enums.ROUTE_ENUM.MASTER_UNIT_DASHBOARD,
      company: [],
      permissionID: Constants.enums.FORM_TEMPLATE_IDS.MASTER_UNIT_DASHBOARD
    },
    {
      label: "Unit Transfer - Form",
      icon: "pi pi-truck",
      route:
        Constants.enums.ROUTE_ENUM.DASHBOARD +
        "/" +
        Constants.enums.FORM_TEMPLATE_IDS.UNIT_TRANSFER_FORM,
      company: [],
      permissionID: Constants.enums.FORM_TEMPLATE_IDS.UNIT_TRANSFER_FORM
    },
    {
      label: "Blade Transfer - Form",
      icon: "pi pi-align-justify",
      route:
        Constants.enums.ROUTE_ENUM.DASHBOARD +
        "/" +
        Constants.enums.FORM_TEMPLATE_IDS.BLADES_TRANSFER_FORM,
      company: [],
      permissionID: Constants.enums.FORM_TEMPLATE_IDS.BLADES_TRANSFER_FORM
    },
    {
      label: "Master Current Inventory Dashboard",
      icon: "pi pi-align-justify",
      route: Constants.enums.ROUTE_ENUM.MASTER_INVENTORY_DASHBOARD,
      company: [],
      permissionID: Constants.enums.FORM_TEMPLATE_IDS.MASTER_INVENTORY_DASHBOARD
    },
    {
      label: "Inventory Reconciliation Dashboard",
      icon: "pi pi-align-justify",
      route: Constants.enums.ROUTE_ENUM.INVENTORY_RECONCILIATION_DASHBOARD,
      company: [],
      permissionID:
        Constants.enums.FORM_TEMPLATE_IDS.INVENTORY_RECONCILIATION_DASHBOARD
    },
    {
      label: "Inventory Count - Form",
      icon: "pi pi-align-justify",
      route:
        Constants.enums.ROUTE_ENUM.DASHBOARD +
        "/" +
        Constants.enums.FORM_TEMPLATE_IDS.INVENTORY_COUNT_FORM,
      company: [],
      permissionID: Constants.enums.FORM_TEMPLATE_IDS.INVENTORY_COUNT_FORM
    },
    {
      label: "QA/QC - Form",
      icon: "pi pi-align-justify",
      route:
        Constants.enums.ROUTE_ENUM.DASHBOARD +
        "/" +
        Constants.enums.FORM_TEMPLATE_IDS.QA_QC_FORM,
      company: [],
      permissionID: Constants.enums.FORM_TEMPLATE_IDS.QA_QC_FORM
    },
    {
      label: "User Profile Dashboard",
      icon: "pi pi-align-justify",
      route:
        Constants.enums.ROUTE_ENUM.DASHBOARD +
        "/" +
        Constants.enums.FORM_TEMPLATE_IDS.USER_PROFILE_DASHBOARD,
      company: [],
      permissionID: Constants.enums.FORM_TEMPLATE_IDS.USER_PROFILE_DASHBOARD
    },
    {
      label: "SR. Management - Form",
      icon: "pi pi-align-justify",
      route: Constants.enums.ROUTE_ENUM.SR_MANAGEMENT_FORM,
      company: [Constants.enums.COMPANY_OPTIONS.CSI],
      permissionID: Constants.enums.FORM_TEMPLATE_IDS.SR_MANAGEMENT_FORM
    },
    {
      label: "Daily Work Examinations - Form",
      icon: "pi pi-align-justify",
      route: Constants.enums.ROUTE_ENUM.DAILY_WORK_EXAMINATION_FORM,
      company: [Constants.enums.COMPANY_OPTIONS.CSI],
      permissionID: Constants.enums.FORM_TEMPLATE_IDS.DAILY_WORK_EXAMINATION_FORM
    },
    {
      label: "Shipping Requests",
      icon: "pi pi-align-justify",
      route: Constants.enums.ROUTE_ENUM.SHIPPING_REQUESTS_DASHBOARD,
      company: [],
      permissionID: Constants.enums.FORM_TEMPLATE_IDS.SHIPPING_REQUESTS_DASHBOARD
    },
    {
      label: "Patrol Report Dashboard",
      icon: "pi pi-align-justify",
      route: Constants.enums.ROUTE_ENUM.PATROL_REPORT_DASHBOARD,
      company: [],
      permissionID: Constants.enums.FORM_TEMPLATE_IDS.PATROL_REPORT_DASHBOARD
    },
    {
      label: "Invoice Forms",
      icon: "pi pi-database",
      route:
        Constants.enums.ROUTE_ENUM.DASHBOARD +
        "/" +
        Constants.enums.FORM_TEMPLATE_IDS.INVOICE_FORM,
      company: [],
      permissionID: Constants.enums.FORM_TEMPLATE_IDS.INVOICE_FORM
    },
    {
      label: "Manbasket Forms",
      icon: "pi pi-database",
      route:
        Constants.enums.ROUTE_ENUM.DASHBOARD +
        "/" +
        Constants.enums.FORM_TEMPLATE_IDS.MANBASKET_INSPECTION_FORM,
      company: [],
      permissionID: Constants.enums.FORM_TEMPLATE_IDS.MANBASKET_INSPECTION_FORM
    },
    {
      label: "BBO Forms",
      icon: "pi pi-database",
      route:
        Constants.enums.ROUTE_ENUM.DASHBOARD +
        "/" +
        Constants.enums.FORM_TEMPLATE_IDS.BEHAVIOUR_BASED_FORM,
      company: [],
      permissionID: Constants.enums.FORM_TEMPLATE_IDS.BEHAVIOUR_BASED_FORM
    },
    {
      label: "Heights Rescue Forms",
      icon: "pi pi-database",
      route:
        Constants.enums.ROUTE_ENUM.DASHBOARD +
        "/" +
        Constants.enums.FORM_TEMPLATE_IDS.HEIGHTS_RESCUE_FORM,
      company: [],
      permissionID: Constants.enums.FORM_TEMPLATE_IDS.HEIGHTS_RESCUE_FORM
    },
    {
      label: "HA Forms",
      icon: "pi pi-database",
      route:
        Constants.enums.ROUTE_ENUM.DASHBOARD +
        "/" +
        Constants.enums.FORM_TEMPLATE_IDS.FLHA_FORM,
      company: [],
      permissionID: Constants.enums.FORM_TEMPLATE_IDS.FLHA_FORM
    },
    {
      label: "Form Templates",
      icon: "pi pi-database",
      route:
        Constants.enums.ROUTE_ENUM.ADMIN +
        Constants.enums.ROUTE_ENUM.FORM_TEMPLATES_DASHBOARD,
      company: [],
      permissionID: Constants.enums.FORM_TEMPLATE_IDS.FORM_TEMPLATES_DASHBOARD
    },
    {
      label: "Form Templates Responses",
      icon: "pi pi-database",
      route:
        Constants.enums.ROUTE_ENUM.ADMIN +
        Constants.enums.ROUTE_ENUM.FORM_TEMPLATES_RESPONSES,
      company: [],
      permissionID: Constants.enums.FORM_TEMPLATE_IDS.FORM_TEMPLATES_RESPONSES
    },
    {
      label: "Forms",
      icon: "pi pi-database",
      route: Constants.enums.ROUTE_ENUM.ADMIN + Constants.enums.ROUTE_ENUM.FORMS,
      company: [],
      permissionID: Constants.enums.FORM_TEMPLATE_IDS.FORMS_DASHBOARD
    },
    {
      label: "Tags",
      icon: "pi pi-tag",
      route: Constants.enums.ROUTE_ENUM.ADMIN + Constants.enums.ROUTE_ENUM.TAGS,
      company: [],
      permissionID: Constants.enums.FORM_TEMPLATE_IDS.TAGS_DASHBOARD
    },
    {
      label: "Trigger Management",
      icon: "pi pi-database",
      route:
        Constants.enums.ROUTE_ENUM.ADMIN +
        Constants.enums.ROUTE_ENUM.TRIGGER_DASHBOARD,
      company: [],
      permissionID:
        Constants.enums.FORM_TEMPLATE_IDS.TRIGGER_MANAGEMENT_DASHBOARD
    },
    {
      label: "Dynamic Report Form",
      icon: "pi pi-th-large",
      route: Constants.enums.ROUTE_ENUM.DYNAMIC_REPORT_FORM,
      company: [],
      permissionID: Constants.enums.FORM_TEMPLATE_IDS.DYNAMIC_REPORT_FORM
    }
  ]);

  // if user is admin then show other options
  if (Helper.isUserAdmin() || Helper.isCurrentEnvironmentDev()) {
    menuItems.value.push(...[]);
  }

  // Keep Home pinned first, then sort the rest A→Z by label
  const sortedMenuItems = computed(() => {
    const items = [...(menuItems.value || [])];
    const home = items.filter((i) => i?.label === "Home");
    const rest = items
      .filter((i) => i?.label !== "Home")
      .sort((a, b) =>
        (a?.label || "").localeCompare(b?.label || "", undefined, {
          sensitivity: "base"
        })
      );

    return [...home, ...rest];
  });

  // Reactive user permissions - automatically updates when permissions store changes
  const loadUserPermissions = computed(() => {
    try {
      const combinedPermissions = permissionsStore.getCombinedPermssions(
        Constants.enums.PERMISSION_LEVELS.READER.key
      );
      const dashboardPermissions = combinedPermissions.dashboard || [];
      return dashboardPermissions.map((item) => item.id).filter(Boolean);
    } catch (error) {
      console.error("Error loading user permissions:", error);
      return null;
    }
  });

  // Filter menu items based on reader dashboard permissions (same as IndexLayout today)
  const filteredMenuItems = computed(() => {
    const userPermissions = loadUserPermissions.value;

    if (!userPermissions) {
      return sortedMenuItems.value.filter((item) => item.permissionID === null);
    }

    // super admin can access everything
    if (
      userPermissions.includes(Constants.enums.SUPER_ADMIN_ID.SUPER_ADMIN_ID)
    ) {
      return sortedMenuItems.value;
    }

    return sortedMenuItems.value.filter((item) => {
      if (!item.permissionID) return true;
      return userPermissions.includes(item.permissionID);
    });
  });

  return {
    companyOptions,
    selectedCompany,
    menuItems,
    sortedMenuItems,
    loadUserPermissions,
    filteredMenuItems
  };
}

